import type { SenderPriorityUsage } from "@/api/custom_types";
export * from "./language";

export const PAGINATION_PAGE_SIZE: number = 25;

export const SenderPriorityUsageEnum = {
	EXCLUDED: "EXCLUDED",
	LOW: "LOW",
	MEDIUM: "MEDIUM",
	HIGH: "HIGH",
	VERY_HIGH: "VERY_HIGH",
} as const satisfies Record<string, SenderPriorityUsage>;
